export default __webpack_public_path__ + "img/police.0c577066.png";